import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdContactSupport } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import { BiSolidDashboard } from "react-icons/bi";
import { FaRegAddressCard, FaUserEdit } from "react-icons/fa";
import { PiContactlessPaymentFill } from "react-icons/pi";

const Sidebar = ({ isCollapsed, setIsCollapsed, isVisible }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeMenu, setActiveMenu] = useState(null);

    useEffect(() => {
        menuItems.forEach((item) => {
            if (item.subItems?.some((sub) => sub.path === location.pathname)) {
                setActiveMenu(item.id);
            }
        });
    }, [location.pathname]);

    const isActive = (path) => location.pathname === path;

    const menuItems = [
        {
            id: "dashboard",
            title: "Dashboard",
            icon: <BiSolidDashboard />,
            path: "/student/dashboard",
        },
        {
            id: "profile",
            title: "Profile",
            icon: <FaUserEdit />,
            path: "/student/profile",
        },
        {
            id: "admission",
            title: "Admission Form",
            icon: <FaRegAddressCard />,
            path: "/student/addmission",
        },
        {
            id: "chalan",
            title: "Chalan",
            icon: <PiContactlessPaymentFill />,
            path: "/student/chalan",
        },
        {
            id: "support",
            title: "Support",
            icon: <MdContactSupport />,
            path: "/student/supports",
        },
    ];

    // Don't render if not visible
    if (!isVisible) return null;


      
      const isPrintPage =
        location.pathname.startsWith("/v2/student/dashboard")

    return (
        <aside className={`sidebar-container ${isCollapsed ? "sidebar-collapsed" : ""}`}>
            <div className="sidebar-menu">
                {menuItems.map((item) => {
                    const isParentActive = 
                        item.subItems?.some((sub) => sub.path === location.pathname) ||
                        isActive(item.path);

                    return (
                        <div key={item.id} className="sidebar-menu-item">
                            {item.path ? (
                                <Link
                                    to={item.path}
                                    className={`sidebar-menu-link ${isParentActive ? "sidebar-menu-link-active" : ""}`}
                                    title={isCollapsed ? item.title : ""}
                                >
                                    <span className="sidebar-menu-icon">{item.icon}</span>
                                    {!isCollapsed && <span>{item.title}</span>}
                                </Link>
                            ) : (
                                <div
                                    onClick={() =>
                                        setActiveMenu(activeMenu === item.id ? null : item.id)
                                    }
                                    className={`sidebar-menu-toggle ${isParentActive ? "sidebar-menu-toggle-active" : ""}`}
                                >
                                    <div className="sidebar-menu-toggle-content">
                                        <span className="sidebar-menu-icon">{item.icon}</span>
                                        {!isCollapsed && <span>{item.title}</span>}
                                    </div>

                                    {!isCollapsed && (
                                        <FaAngleDown
                                            className={`sidebar-menu-arrow ${activeMenu === item.id ? "sidebar-menu-arrow-rotated" : ""}`}
                                        />
                                    )}
                                </div>
                            )}

                            {activeMenu === item.id && item.subItems && !isCollapsed && (
                                <div className="sidebar-submenu">
                                    {item.subItems.map((sub) => (
                                        <Link
                                            key={sub.title}
                                            to={sub.path}
                                            className={`sidebar-submenu-link ${isActive(sub.path) ? "sidebar-submenu-link-active" : ""}`}
                                        >
                                            {sub.title}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="sidebar-footer">
                <div
                    onClick={() => {
                        if(window.confirm("Are you want to logout ")){
                            localStorage.removeItem("auth_token");
                        navigate("/student/login");  
                        }
                      
                    }}
                    className="sidebar-logout"
                >
                    <FiLogOut />
                    {!isCollapsed && <span>Logout</span>}
                </div>
            </div>
        </aside>
    );
};

export default Sidebar